import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, useSlots, watch, onMounted, toRef } from 'vue';
import { store } from '@/store';
import userAgent from '@/services/userAgent.service';
import { useSwiper, ManagedSwiper, SwiperPagination } from '@/ui/shared/swiper';
import { useOnWindowResize } from '@/ui/composables/';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockTextAndImage',
  props: {
    images: { default: () => [] as ImageWithLinkViewObject[] },
    alignTextCenter: { type: Boolean },
    backgroundColor: { default: '' }
  },
  setup(__props: any) {

const props = __props as { images: ImageWithLinkViewObject[], alignTextCenter?: boolean, backgroundColor: string }



const dynamicHeightSwiper = ref();

const { swiperManager } = useSwiper<ImageWithLinkViewObject>({
    slides: toRef(props, 'images'),
    swiperOptions: {
        direction: 'horizontal',
        loop: true
    }
});

const updateSwiperHeight = () => {
    const activeSlideElement = swiperManager.getActiveSlideElement();
    if (!activeSlideElement) {
        return;
    }
    const img = activeSlideElement.querySelector('img');
    if (!img) {
        return;
    }
    const imgHeight = img.clientHeight;
    if (imgHeight === 0) {
        img.onload = () => {
            dynamicHeightSwiper.value.style.height = img.clientHeight + 'px';
        };
    }
    dynamicHeightSwiper.value.style.height = img.clientHeight + 'px';
};

useOnWindowResize(() => {
    window.requestAnimationFrame(() => {
        updateSwiperHeight();
    });
});

watch(swiperManager.activeSlide, (activeSlide) => {
    if (!activeSlide) {
        return;
    }
    updateSwiperHeight();
});

onMounted(() => {
    window.setTimeout(() => {
        updateSwiperHeight();
    }, 200);
});

const isInEditMode = computed<boolean>(() => store.getters['app/isInEditMode']);

const hasAnyImageTitles = computed<boolean>(() => props.images.some(image => image.title !== ''));

const runTextAnimation = ref<boolean>(userAgent.isPrerender);
const runImageAnimation = ref<boolean>(userAgent.isPrerender);

function hasImage(): boolean {
    return props.images.length > 0;
}

function initTextAnimation(): void {
    runTextAnimation.value = true;
}

function initImageAnimation(): void {
    runImageAnimation.value = true;
}

function hasIntroText(): boolean {
    return isSlotEmpty('intro-text');
}

function hasBodyText(): boolean {
    return isSlotEmpty('body-text');
}

function hasImageCaption(): boolean {
    return isSlotEmpty('image-caption');
}

const slots = useSlots();

function isSlotEmpty(slotName: string): boolean {
    const slot = slots[slotName];
    return slot !== undefined;
}

return { __sfc: true,props, dynamicHeightSwiper, swiperManager, updateSwiperHeight, isInEditMode, hasAnyImageTitles, runTextAnimation, runImageAnimation, hasImage, initTextAnimation, initImageAnimation, hasIntroText, hasBodyText, hasImageCaption, slots, isSlotEmpty, ManagedSwiper, SwiperPagination }
}

})